/**
 * Returns a copy of the array without duplicate elements
 * @param arr
 */
export const unique = (arr: (string | number)[]): (string | number)[] =>
  arr.filter((value, index, array) => array.indexOf(value) === index)
